'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'theme-background-color-pay-blue': '#003087',
  'theme-background-color-pal-blue': '#009cde',
  'theme-background-color-purple': '#640487',
  'theme-background-color-pink': '#de0063',
  'theme-background-color-orange': '#ff9600',
  'theme-background-color-green': '#299976'
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/ds-header/themeColors.js
// module id = 674
// module chunks = 4